<template>
  <tippy-tooltip
    content="Record"
    :class="$attrs.class"
  >
    <tippy-bounce-button
      v-bind="{...$attrs, class: undefined}"
      store-key="start-recording-button:clicked"
      tippy-content="Click to record"
      class="d-inline-block"
      :tippy-options="{placement: 'left'}"
    >
      <div class="start-recording-button__inner"></div>
    </tippy-bounce-button>
  </tippy-tooltip>
</template>

<script>
import TippyBounceButton from '../../../common/tippy-bounce-button.vue'
import TippyTooltip from '../../../common/tippy-tooltip.vue'

export default {
  name: 'WebcamRecorderStartRecordingButton',
  components: { TippyTooltip, TippyBounceButton },
  inheritAttrs: false
}
</script>

<style lang="scss" scoped>
.start-recording-button {
  &__inner {
    width: 30px;
    height: 30px;
    background: red;
    border-radius: 50%;
    display: inline-block;
    margin-top: 3px;
  }
}

</style>
